let resumeData = {
  imagebaseurl: "https://github.com/Omar4GH",
  name: "Omar Ghamrawi",
  role: "Software Engineer",
  linkedinId: "https://www.linkedin.com/in/omarghamrawi/",
  roleDescription:
    "I'm a 25-year-old Lebanese software engineer based in Lebanon. I've always had a passion for programming, game and web development, and I'm constantly eager to learn new things. In my free time, I enjoy photography, parkour and freerunning, video editing, and gaming.",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/omarghamrawi/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/Omar4GH",
      className: "fa fa-github",
    },
    {
      name: "youtube",
      url: "https://www.youtube.com/channel/UC4dExORzyUiPRtXmn8eWZiQ",
      className: "fa fa-youtube",
    },
    {
      name: "500px",
      url: "https://500px.com/p/Omar-GH?view=photos",
      className: "fa fa-picture-o",
    },
    {
      name: "instagram",
      url: "https://www.instagram.com/omarghamrawi/?hl=en",
      className: "fa fa-instagram",
    },
  ],
  aboutme: `I'm a Software Engineer and Boğaziçi University graduate with a broad skill set across full-stack development, automation, and desktop applications. My experience spans working with Node.js, React (JS/TS), Electron, React Native, PostgreSQL, MongoDB, and MySQL, developing both frontend and backend systems, including UI-focused desktop apps, scalable backend services, and cross-platform mobile applications for Android and iOS.

I've built and maintained full-stack applications, deployed projects using Docker, AWS, Google Cloud, and handled everything from debugging and feature development to infrastructure and deployment. I'm also experienced in integrating AI services and models into applications to enhance functionality and user experience.

I'm always excited to learn new technologies and quickly adapt to unfamiliar tools — whether it's mastering new frameworks, languages, or diving into any challenge that comes my way.

Comfortable in both team-based and independent workflows, I follow GitHub best practices including issue tracking, branching strategies, and pull request reviews. I also have hands-on experience with Android Studio, Unity, and languages like C, C#, Java, PHP, and JavaScript/HTML/CSS.`,
  address: "Tripoli, Lebanon",
  email: "omarghamrawi18@gmail.com",
  website: "",
  education: [
    {
      UniversityName: "Boğaziçi University",
      specialization: "Master's in Software Engineering",
      gpa: "3.3",
      MonthOfPassing: "October",
      YearOfPassing: "2022 - 2024",
      Achievements: "Istanbul, Turkey",
    },
    {
      UniversityName: "Uskudar University",
      specialization: "Bachelor's in Software Engineering",
      gpa: "3.2",
      MonthOfPassing: "",
      YearOfPassing: "2018 - 2022",
      Achievements: "Istanbul, Turkey",
    },
    {
      UniversityName: "Azm Institute",
      specialization: "Information Technology",
      gpa: "2.93",
      MonthOfPassing: "",
      YearOfPassing: "2016 - 2018",
      Achievements: "Tripoli, Lebanon",
    },
  ],
  certificates: [
    {
      UniversityName: "Software Engineer - Bachelor of Science",
      specialization: "Uskudar University - Bachelor's Degree in Software Engineering | GPA 3.2",
      MonthOfPassing: "August",
      YearOfPassing: "2022",
      Achievements: "Istanbul, Turkey",
    },
    {
      UniversityName: "Professional Diploma Program in Information Technology",
      specialization: "Azm Institute, Pearson Assured | GPA 2.93",
      MonthOfPassing: "July",
      YearOfPassing: "2018",
      Achievements: "Tripoli, Lebanon",
    },
    {
      UniversityName: "Cisco - CCNA Routing and Switching",
      specialization: "Cisco Certified Network Associate - Course Completion",
      MonthOfPassing: "April",
      YearOfPassing: "2018",
      Achievements: "Tripoli, Lebanon",
    },
    {
      UniversityName: "Unity - Networking and VR Level 3",
      specialization: "Al Amine International Academy For Training And Development",
      MonthOfPassing: "July",
      YearOfPassing: "2017",
      Achievements: "Tripoli, Lebanon",
    },
    {
      UniversityName: "Unity - Advanced Level 2",
      specialization: "Al Amine International Academy For Training And Development",
      MonthOfPassing: "May",
      YearOfPassing: "2017",
      Achievements: "Tripoli, Lebanon",
    },
    {
      UniversityName: "Unity - How To Make A Video Game Level 1",
      specialization: "Al Amine International Academy For Training And Development",
      MonthOfPassing: "February",
      YearOfPassing: "2017",
      Achievements: "Tripoli, Lebanon",
    },
    {
      UniversityName: "LAU - Computing Summer Camp",
      specialization: "Lebanese American University - 3rd Place",
      MonthOfPassing: "July",
      YearOfPassing: "2016",
      Achievements: "Tripoli, Lebanon",
    },
    {
      UniversityName: "Cisco - IT Essentials",
      specialization: "IT Essentials at Cisco Networking Academy | Score: 95.9%",
      MonthOfPassing: "September",
      YearOfPassing: "2014",
      Achievements: "Tripoli, Lebanon",
    },
  ],
  work: [
    {
      CompanyName: "AIY Expert Solutions",
      specialization: "Junior Software Engineer (On-site)",
      MonthOfLeaving: "January",
      YearOfLeaving: "2025 - Present",
      Achievements: `Built automation-driven backend, frontend, and desktop applications (Node.js, TS, Electron,
Angular) and analyzed complex web flows using advanced proxy debugging utilities to
create robust, high-performing modules.
Designed clean, intuitive user interfaces and leveraged AI tools like GitHub Copilot
assistants to speed up development and enhance code quality.
Collaborated on planning, deployment, debugging, and system design while adapting quickly
to any changing requirements`,
    },
    {
      CompanyName: "AIY Expert Solutions",
      specialization: "Software Engineer Intern (On-site)",
      MonthOfLeaving: "August",
      YearOfLeaving: "2024 - January 2025",
      Achievements: "Completed internship focused on full-stack development, contributing to both frontend and backend systems.",
    },
    {
      CompanyName: "DevTech",
      specialization: "Software Engineer Intern - Frontend & Backend",
      MonthOfLeaving: "July",
      YearOfLeaving: "2022 - September 2023",
      Achievements: "React.js projects | CSS design/Tailwind | React Libraries | Axios API calls | Database integration | Crypto Wallet & Payment Processor Integration | E-commerce Yii2 website maintenance | GitHub workflow (Branches, Pull Requests, Reviews) | Docker, MongoDB, XAMPP, PhpMyAdmin, Postman",
    },
    {
      CompanyName: "Freelance",
      specialization: "Video & Photo Editor",
      MonthOfLeaving: "",
      YearOfLeaving: "Ongoing",
      Achievements: "Professional video and photo editing using Adobe Premiere Pro, Lightroom, Photoshop, and After Effects",
    },
  ],
  skillsDescription: "",
  skills: [
    { skillname: "ReactJS", proficiency: 95 },
    { skillname: "ReactTS", proficiency: 90 },
    { skillname: "ReactNative", proficiency: 75 },
    { skillname: "NodeJS", proficiency: 85 },
    { skillname: "MongoDB", proficiency: 80 },
    { skillname: "MySQL", proficiency: 85 },
    { skillname: "PostgreSQL", proficiency: 75 },
    { skillname: "CSS", proficiency: 90 },
    { skillname: "AWS", proficiency: 75 },
    { skillname: "Docker", proficiency: 70 },
    { skillname: "HTML5", proficiency: 95 },
    { skillname: "Javascript", proficiency: 90 },
    { skillname: "Java", proficiency: 85 },
    { skillname: "PHP", proficiency: 70 },
    { skillname: "C", proficiency: 80 },
    { skillname: "Unity Engine", proficiency: 85 },
    { skillname: "Adobe Softwares", proficiency: 90 },
    { skillname: "Angular", proficiency: 80 },
    { skillname: "Electron", proficiency: 80 },
    { skillname: "C#", proficiency: 50 },
    { skillname: "Blender", proficiency: 30 },
    { skillname: "Git", proficiency: 90 },
    { skillname: "Network Debugging", proficiency: 70 },
    { skillname: "Video Editing", proficiency: 90 },
    { skillname: "AI-assisted Development", proficiency: 100 },
  ],
  portfolio: [
    {
      name: "Vivid",
      subtitle: "Latest Youtube Video",
      websiteUrl: "https://www.youtube.com/channel/UC4dExORzyUiPRtXmn8eWZiQ",
      description: "My YouTube channel where I share edited videos and creative experiences.",
      imgurl: "images/portfolio/phone.jpg",
      url: "https://www.youtube.com/embed/CpjIoBKG5J8?si=6zyQR8AUi1_t3eoS",
    },
    {
      name: "GeoMemoirs",
      subtitle: "Web Application",
      websiteUrl: "https://geo-memoirs.netlify.app/",
      description: "A React application built for SWE-573, MSc. Software Engineering at Boğaziçi University (2023). Features Node.js backend with MySQL database. Backend deployed on AWS as a Docker image, frontend hosted on Netlify.",
      imgurl: "images/DSC_0296.jpg",
      url: "https://www.youtube.com/embed/bcEXsGODIY0?si=ddXZYxrAJ9QYAtv0",
    },
    {
      name: "SmartJobs",
      subtitle: "Web Application",
      websiteUrl: "https://smart-jobs.netlify.app/",
      description: "Job posting platform developed with React.js frontend and Node.js backend using MongoDB. Features include weekly digest emails, job recommendations, and saved job reminders. Deployed on AWS.",
      imgurl: "images/portfolio/smartjobs.png",
      url: "https://www.youtube.com/embed/1AH9fTT5n44?si=pk6BfPFZVRudkVKF",
    },
    {
      name: "LivingStories Mobile App",
      subtitle: "Mobile Application",
      websiteUrl: "https://www.youtube.com/watch?v=fRT3WcLz9Qk",
      description: "Cross-platform mobile application developed using React Native for Android and iOS.",
      imgurl: "images/portfolio/livingstories.png",
      url: "https://www.youtube.com/embed/fRT3WcLz9Qk?si=HWbH9R2vT9w351hx",
    },
    {
      name: "LivingStories Web Frontend",
      subtitle: "Web Application",
      websiteUrl: "https://www.youtube.com/watch?v=n-zY_CPTbWg",
      description: "Frontend development as part of a collaborative team project, focusing on user interface and experience.",
      imgurl: "images/portfolio/livingstories.png",
      url: "https://www.youtube.com/embed/n-zY_CPTbWg?si=fs4FaYAxiSCgg9s4",
    },
    {
      name: "LucidMonkee",
      subtitle: "Unity Game",
      websiteUrl: "https://www.youtube.com/watch?v=qND2xdlTUSM&ab_channel=OmarGhamrawi",
      description: "3D first-person shooter game created in Unity Engine. Currently in development, featuring custom assets created in Blender alongside free internet resources.",
      imgurl: "images/portfolio/project2.png",
      url: "https://www.youtube.com/embed/qND2xdlTUSM?si=Bb4_IQvqs27JqKkc",
    },
  ],
  freelanceProjects: [
    {
      name: "Van Belle",
      url: "https://vanbelle-lb.com/",
      description: "Professional e-commerce website for Chocolatier Van Belle",
      category: "E-commerce",
    },
    {
      name: "Pack Plus",
      url: "https://www.packpluslb.com/",
      description: "Professional e-commerce website for Pack Plus Lebanon",
      category: "E-commerce",
    },
    {
      name: "Ghanem Safes",
      url: "https://ghanemsafes.com/",
      description: "Business website for Ghanem Safes",
      category: "Corporate",
    },
      {
      name: "AI Lawyer Assistant",
      url: "",
      description: "AI-powered legal chat assistant through WhatsApp",
      category: "AI",
    },
  ],
  testimonials: [],
};

export default resumeData;
